export default __webpack_public_path__ + "static/media/team-building.10fff7e9.svg";